<div id="acom">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class=" inner-card">
          <h4 class="card-title">Games and Sports</h4>
          <div class="card-body text-justify">
            <p class="lead text-justify inner-lead">Children are the harbingers of change; they are the flag-bearers of
              a nation. Adequate emphasis is laid on the holistic development of a child. Sports and games are an
              indispensable part of our curriculum where children participate and excel in a range of activities. The
              campus proudly possesses a vast playground with a 200-metre track, a football ground, a volleyball court,
              a basketball court, a handball court, a cricket cage and a skating rink. The school has a well-maintained
              gymnasium for indoor activities like chess, table tennis, carrom, boxing, martial arts/ self-defence,
              yoga, aerobics and zumba. We have swings, slides and seesaws for the children of Pre-Primary classes. </p>

            <p class="lead text-justify inner-lead">The school has well-qualified physical instructors to impart
              intensive and exclusive training to our students in various outdoor and indoor activities.
              Students compete with their counterparts of other houses in various team and athletic events. The
              performance of The Best House is appreciated by awarding The Best House Trophy.
            </p>
            <p class="inner-lead">Our students also participate at the District, State and National levels and bring
              laurels by winning top positions.</p>
            <div id="gamesCarousel" class="carousel slide" data-ride="carousel">
              <div class="carousel-indicators">
                <button type="button" data-bs-target="#gamesCarousel" *ngFor="let img of imgUrl, let i = index"
                  class="{{ (i == 0) ? 'active' : '' }}" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1"
                  attr.data-bs-slide-to="{{i}}"></button>
              </div>
              <div class="carousel-inner text-center py-5 px-3">
                <div class="carousel-item" *ngFor="let img of imgUrl, let i=index"
                  [ngClass]="(i == 0 ) ? 'active' : ''">
                  <a appLazyload href="{{img}}" data-lightbox="Games"><img appLazyload [src]="img" alt="Games"
                      class="img-fluid rounded"></a>
                </div>
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#gamesCarousel" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#gamesCarousel" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>


  </div>
</div>